import {
  GET_LETTER_ORDERS_ADDRESSES_REQUEST,
  GET_LETTER_ORDERS_ADDRESSES_SUCCESS,
  GET_LETTER_ORDERS_ADDRESSES_FAILURE,
} from "../../constants/ActionTypes";

import { LetterOrdersApi } from "../api/LetterOrdersApi";

/*** GET /letter-orders/{id}/addresses ***/
const getLetterOrdersAddressesRequest = (overwrite) => ({
  type: GET_LETTER_ORDERS_ADDRESSES_REQUEST,
  payload: {
    overwrite: overwrite,
  },
});

const getLetterOrdersAddressesSuccess = (addresses, pageInfo, overwrite) => ({
  type: GET_LETTER_ORDERS_ADDRESSES_SUCCESS,
  payload: {
    addresses: addresses,
    pageInfo: pageInfo,
    overwrite: overwrite,
  },
});

const getLetterOrdersAddressesFailure = (error) => ({
  type: GET_LETTER_ORDERS_ADDRESSES_FAILURE,
  payload: {
    error: error,
  },
});

export function getLetterOrdersAddresses(id, data, overwrite) {
  return async (dispatch) => {
    dispatch(getLetterOrdersAddressesRequest(overwrite));

    LetterOrdersApi.getLetterOrdersAddresses(id, data, dispatch)
      .then((response) => {
        dispatch(
          getLetterOrdersAddressesSuccess(
            response.data.data,
            response.data.meta,
            overwrite
          )
        );
      })
      .catch((error) => {
        dispatch(getLetterOrdersAddressesFailure(error.response));
      });
  };
}




// WEBPACK FOOTER //
// ./src/redux/actions/LetterOrderDetail.js